//external
import React, { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
//internal
import { getGroup, putGroup } from 'services/productGroup/service'
import { startRequest, finishRequest } from 'store/modules/loading/actions';
import history from 'services/history';
import ContentPanel from 'components/ContentPanel'
import { validateForm } from 'components/Form/validate'
import { setMessage } from 'store/modules/message/action'
import { groupSchema } from '../schemas'
import GridContainer from 'components/v2/grid';
import InputText from 'components/v2/inputText';
import { sanitizeErrorUI } from 'utils/errorUtil';
import { Warning } from 'routes/Route';
//style
import { Button, ButtonContainer } from 'styles/components'
import Toggle from 'components/v2/toggle';

export default function Group({match}) {
  const message = useSelector(state => state.message.data);
  const groupId = match.params.id;
  const [dataGroup, setDataGroup] = useState({
    protheusCode: "",
    description: "",
    descriptionAlias: "",
    expirationDate: "",
    ignoreExpirationDate: false,
  })
  const [errors, setErrors] = useState([]);

  const { setNotWarning } = useContext(Warning);

  const dispatch = useDispatch();

  useEffect(() => {
    if (groupId) {
      dispatch(startRequest());
      getGroup(groupId).then(data => {
        const formData = data.data;
        setDataGroup({
          protheusCode: formData.protheusCode,
          description: formData.description,
          descriptionAlias: formData.descriptionAlias,
          expirationDate: formData.expirationDate,
          ignoreExpirationDate: formData.ignoreExpirationDate,
        })
      }).catch(err => {
        dispatch(setMessage(sanitizeErrorUI(err)));
      }).finally(() => {
        dispatch(finishRequest());
      });
    }
  }, [dispatch, groupId])

  async function handleSubmit () {
    setNotWarning();
    const errorsList = await validateForm(dataGroup, groupSchema);
    if (errorsList.length > 0) {
      setErrors(errorsList);
      return;
    } 

    dispatch(startRequest());
    putGroup(groupId, dataGroup).then(data => {
      history.push('/premixlabel/product_group')
    }).catch(err => {
      dispatch(setMessage(sanitizeErrorUI(err)));
    }).finally(() => {
      dispatch(finishRequest());
    });    
  }

  return (
    <ContentPanel title='Grupo de produto' message={message}>
      <GridContainer>
        <InputText
          xs={12}
          sm={6}
          required
          name="protheusCode"
          label="Código"
          type="text"
          value={dataGroup.protheusCode}
          onChange={(e) => setDataGroup({...dataGroup, protheusCode: e.target.value})}
          errors={errors} 
          disabled={true}
        />

        <InputText
          xs={12}
          sm={6}
          required
          name="description"
          label="Descrição"
          type="text"
          value={dataGroup.description}
          onChange={(e) => setDataGroup({...dataGroup, description: e.target.value})}
          errors={errors} 
          disabled={true}
        /> 
  
        <InputText
          xs={12}
          sm={6}
          required
          name="expirationDate"
          label="Validade em Meses"
          type="number"
          placeholder="Validade em Meses"
          value={dataGroup.expirationDate}
          onChange={(e) => setDataGroup({...dataGroup, expirationDate: e.target.value})}
          errors={errors} 
        /> 

        <InputText
          xs={12}
          sm={6}
          name="descriptionAlias"
          label="Rótulo"
          type="text"
          placeholder="Rótulo"
          value={dataGroup.descriptionAlias}
          onChange={(e) => setDataGroup({...dataGroup, descriptionAlias: e.target.value})}
          errors={errors} 
        />
        
        <Toggle
          xs={6}
          sm={6}
          name="Ignora validade"
          checked={dataGroup.ignoreExpirationDate}
          onChange={(e) => setDataGroup({...dataGroup, ignoreExpirationDate: e.target.checked})}
          label="Ignora validade"
        />
      </GridContainer>

      <ButtonContainer>
        <Button type="submit" onClick={handleSubmit}>Salvar</Button>
      </ButtonContainer>
    </ContentPanel>
  )
}